export default __webpack_public_path__ + "static/media/pp-title-en.ea31f9d5.webp";